/**
 * Utility functions for URL manipulation
 */

/**
 * Appends query parameters to a URI string
 * @param uri - The base URI (can already contain query parameters)
 * @param queryParams - An object containing key-value pairs of query parameters to append
 * @returns The URI with the new query parameters appended
 */
export function appendUrlQueryParams(uri: string, queryParams: Record<string, string>): string {
    if (!uri || !Object.keys(queryParams).length) return uri;

    const [path, paramsString] = uri.split('?');
    const searchParams = new URLSearchParams(paramsString);

    Object.entries(queryParams).forEach(([key, value]) => {
        searchParams.set(key, value);
    });

    return `${path}?${searchParams.toString()}`;
}
